interface IBookmarkIconProps {
  isFilled?: boolean;
}

export const BookmarkIcon = ({ isFilled = false }: IBookmarkIconProps) => (
  <svg fill={isFilled ? 'currentColor' : 'none'} stroke='currentColor' viewBox='0 0 24 24' width='22' xmlns='http://www.w3.org/2000/svg'>
    <path d='M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z' strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} />
  </svg>
);
